import Modal from "@common/Modal";
import { useEffect } from "react";

const AddApplicationThankPopup = (props: any) => {
    let { show, screenType } = props;

    useEffect(() => {
        if (show) {
            document.body.classList.add("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])
    return (
        <div className="model-outer upload-success-popup">
            <Modal show={show} handleClose={() => props.handleClose()} screenType={screenType}>

                <div className="modal-body" >
                    <div className='upload-success-msg'>
                        <div className='check-icn'>
                            <i className='ic-check'></i>
                        </div>
                        <span className='thanks-txt'>
                            {screenType === "REGISTER" && "Thank You For Your"}
                            {screenType === "CHANGE_PASSWORD" && "Password has been changed successfully"}
                            {screenType !== "REGISTER" && screenType !== "CHANGE_PASSWORD" &&
                                "Thank You For Application Submission!"}
                        </span>
                        {screenType && screenType === "REGISTER" &&
                            <span className='registration-txt'>Registration</span>
                        }

                        <div className="id-number">
                            {screenType === "REGISTER" &&
                                "Our team will get back to you shortly"}
                            {screenType === "CHANGE_PASSWORD" && ""}
                            {screenType !== "REGISTER" && screenType !== "CHANGE_PASSWORD" &&
                                `Your Application ID is ${props.leadId || ""}`}
                        </div>
                    </div>
                </div>
                <div className='modal-footer m-lg-t'>
                    {screenType === "REGISTER" && (
                        <button
                            className="btn-primary btn-white"
                            onClick={() => props.navigateToLogin()}
                        >
                            Okay
                        </button>
                    )}
                    {screenType === "CHANGE_PASSWORD" && (
                        <button
                            className="btn-primary btn-white"
                            onClick={() => props.navigateToProfile()}
                        >
                            Okay
                        </button>
                    )}
                    {screenType !== "REGISTER" && screenType !== "CHANGE_PASSWORD" && (
                        <button
                            className="btn-primary btn-white"
                            onClick={() => props.handleClose()}
                        >
                            Okay
                        </button>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default AddApplicationThankPopup;